import Vue from 'vue'
import tehnicallabs from '../../api/tehnicallabs'

// initial state
const state = {
  tehnicallabs: {root: [], totalCount: 0},
  saveTehnicalLabResponse: false,
  deleteTehnicalLabResponse: false
}

// getters
const getters = {
  tehnicallabs: state => state.tehnicallabs,
  saveTehnicalLabResponse: state => state.saveTehnicalLabResponse,
  deleteTehnicalLabResponse: state => state.deleteTehnicalLabResponse
}

// actions
const actions = {
  getTehnicalLabs: function (context, data) {
    tehnicallabs.getTehnicalLabs(data, tehnicallabs => {
      context.commit('RECEIVE_LAB', { tehnicallabs })
    })
  },
  saveTehnicalLab: function (context, data) {
    tehnicallabs.saveTehnicalLab(data, saveTehnicalLabResponse => {
      context.commit('SAVE_RESPONSE', { saveTehnicalLabResponse })
    })
  },
  deleteTehnicalLab: function (context, data) {
    tehnicallabs.deleteTehnicalLab(data, deleteTehnicalLabResponse => {
      context.commit('DELETE_RESPONSE', { deleteTehnicalLabResponse })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_LAB'] (state, { tehnicallabs }) {
    tehnicallabs.totalCount = parseInt(tehnicallabs.totalCount)
    state.tehnicallabs = tehnicallabs
  },
  ['SAVE_RESPONSE'] (state, { saveTehnicalLabResponse }) {
    state.saveTehnicalLabResponse = saveTehnicalLabResponse
  },
  ['DELETE_RESPONSE'] (state, { deleteTehnicalLabResponse }) {
    if(deleteTehnicalLabResponse.error == true) Vue.$notify.error(deleteTehnicalLabResponse.notice);
    else Vue.$notify.success(deleteTehnicalLabResponse.notice);
    state.deleteTehnicalLabResponse = deleteTehnicalLabResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tehnicallabs.js